import React from 'react'

import { Props } from './types'

import styles from './styles.module.scss'

export const TextEditorError: React.FC<Props> = ({ error, text }) => {
	if (!error) {
		return null
	}
	return (
		<>
			{['max', 'maxHtmlString', 'maxHtmlStringWithEscapes'].some(
				(errorType) => error.type === errorType
			) ? (
				<div className={styles.error}>{text}</div>
			) : null}
		</>
	)
}

export default TextEditorError
